const SESSION_EXPIRES_AT_KEY = "session_expires_at";
const SESSION_UPDATED_EVENT = "session-timeout-updated";
const WARNING_OFFSET_MS = 65000;
const DEFAULT_TIMEOUT_MS = 300000;

const parsePositiveInt = (value, fallback) => {
  const parsed = parseInt(value, 10);
  return parsed > 0 ? parsed : fallback;
};

export const getTimeoutMs = () => {
  return parsePositiveInt(
    window.localStorage.getItem("timeout"),
    DEFAULT_TIMEOUT_MS
  );
};

export const getExpiresAt = () => {
  return parsePositiveInt(window.localStorage.getItem(SESSION_EXPIRES_AT_KEY), 0);
};

export const getWarningOffsetMs = () => {
  return WARNING_OFFSET_MS;
};

export const refreshSessionTimeout = (timeoutMs) => {
  const duration = parsePositiveInt(timeoutMs, getTimeoutMs());
  const expiresAt = Date.now() + duration;
  window.localStorage.setItem(SESSION_EXPIRES_AT_KEY, String(expiresAt));
  window.dispatchEvent(
    new CustomEvent(SESSION_UPDATED_EVENT, {
      detail: { expiresAt },
    })
  );
  return expiresAt;
};

export const clearSessionTimeout = () => {
  window.localStorage.removeItem(SESSION_EXPIRES_AT_KEY);
  window.dispatchEvent(
    new CustomEvent(SESSION_UPDATED_EVENT, {
      detail: { expiresAt: 0 },
    })
  );
};

export default {
  getTimeoutMs,
  getExpiresAt,
  getWarningOffsetMs,
  refreshSessionTimeout,
  clearSessionTimeout,
  SESSION_UPDATED_EVENT,
};
